// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"1d137d56","60":"1d137d56","128":"1d137d56","143":"e3879c35","850":"1d137d56","909":"1d137d56","986":"1d137d56"}[chunkId] + ".chunk.css";
};